module.exports = __webpack_public_path__ + "img/okex_sign.96bce1e9.svg";